import React from 'react'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { UsuarioAPI } from '../../../api'
import { Alerts } from '../../Simple'

export default function SettingsHook() {
  const { userUCtx, actionsUCtx } = React.useContext(UsuarioContext)

  const [sttPgStt, setSttPgStt] = React.useState({
    showEmail: false,
    showNewPass: false,
    newPassOk: false,
    labelEmail: '',
  })
  const [inpsStt, setInpsStt] = React.useState({
    newReserva: userUCtx.usuario.emailUsuarioNovaReserva || false,
    newReservaAprovada: userUCtx.usuario.emailUsuarioReservaAprovada || false,
    newReservacancelada: userUCtx.usuario.emailUsuarioReservaCancelada || false,
    email: userUCtx.usuario.usuario || '',
    nome: userUCtx.usuario.nome || '',
    nascimento: userUCtx.usuario.atleta.nascimento || '',
    telefone: userUCtx.usuario.atleta.telefone || '',
    genero: userUCtx.usuario.atleta.sexo || '',
    pais: '+55',
    senha: '',
    newSenha: '',
    confirmSenha: '',
  })
  const [loadStt, setLoadStt] = React.useState({
    page: false,
    alterDados: false,
    newPass: false,
    validEmail: false,
    envioEmails: false,
  })

  React.useEffect(() => {
    if (inpsStt.newSenha.length > 4 && inpsStt.newSenha !== inpsStt.confirmSenha) {
      setSttPgStt(sttPgStt => ({ ...sttPgStt, newPassOk: true }))
    } else {
      setSttPgStt({ ...sttPgStt, newPassOk: false })
    }
  }, [inpsStt.newSenha, inpsStt.confirmSenha])

  const actionsSettings = {
    SavedChangeUser: async () => {
      // Verifica se os dados estão diferentes para atualizar
      setLoadStt({ ...loadStt, alterDados: true })
      const user = {
        ...userUCtx.usuario,
        // parte dos emails tbm
        emailUsuarioNovaReserva: inpsStt.newReserva,
        emailUsuarioReservaAprovada: inpsStt.newReservaAprovada,
        emailUsuarioReservaCancelada: inpsStt.newReservacancelada,
        nome: inpsStt.nome,
        atleta: {
          ...userUCtx.usuario.atleta,
          telefone: inpsStt.telefone,
          sexo: inpsStt.genero,
          nascimento: inpsStt.nascimento,
        },
      }
      delete user.senha
      let flag = false
      if (user.atleta && user.atleta.nascimento) {
        if (user.atleta.nascimento.length === 10 && user.atleta.nascimento.includes('-')) {
          const data = user.atleta.nascimento.split('-')
          user.atleta.nascimento = `${data[2]}/${data[1]}/${data[0]}`
          flag = true
        }
      }
      const req = await UsuarioAPI.AtualizarUsuario(user)
      // Retorna data para yyyy-mm-dd
      if (flag) {
        const data = user.atleta.nascimento.split('/')
        user.atleta.nascimento = `${data[2]}-${data[1]}-${data[0]}`
      }
      if (req.retorno) {
        Alerts.swal('success', 'Dados atualizados', 'Seus dados foram atualizados com sucesso.')
        actionsUCtx.handleUsuario(user)
      }

      setLoadStt({ ...loadStt, alterDados: false })
      if (req.error) {
        return Alerts.swal(
          'warning',
          'Aviso',
          `Não foi possível atualizar seus dados, por favor verifique suas credenciais e tente novamente.`,
        )
      }
    },
    verificaAlteracoes: () => {
      if (
        inpsStt.nome !== userUCtx.usuario.nome ||
        inpsStt.telefone !== userUCtx.usuario.atleta.telefone ||
        inpsStt.genero !== userUCtx.usuario.atleta.sexo ||
        inpsStt.nascimento !== userUCtx.usuario.atleta.nascimento ||
        inpsStt.newReserva !== userUCtx.usuario.emailUsuarioNovaReserva ||
        inpsStt.newReservaAprovada !== userUCtx.usuario.emailUsuarioReservaAprovada ||
        inpsStt.newReservacancelada !== userUCtx.usuario.emailUsuarioReservaCancelada
      ) {
        return false
      }
      return true
    },
    handleInpsStt: (key, value) => {
      setInpsStt(inpsStt => ({ ...inpsStt, [key]: value }))
    },
    handleLoadStt: (key, value) => {
      setLoadStt(loadStt => ({ ...loadStt, [key]: value }))
    },
    handleSttPgStt: (key, value) => {
      setSttPgStt(sttPgStt => ({ ...sttPgStt, [key]: value }))
    },
    clearPassInps: () => {
      setInpsStt(inpsStt => ({ ...inpsStt, senha: '', newSenha: '', confirmSenha: '' }))
    },
  }

  return { sttPgStt, inpsStt, loadStt, actionsSettings }
}
